import { apiResolver, useApi } from "@/api/useApi";
import { useConfigManager } from "./useConfigManager";
import { useMemo } from "react";

interface QuackchatSessionConfiguration {
  showCsat: boolean;
  checkAiResolvedAfterSeconds: number;
  checkInactivityTimeoutAfterSeconds: number;
  followUpReminderAfterSeconds: number;
  followUpCount: number;
  autoFillEscalationEmailIfEmailExists: boolean;
  liveAgentBusyTimeoutAfterSeconds: number;
  askEmailAfterFirstMessage: boolean;
  askEmailAfterFirstMessageOnlyIfMissing: boolean;
  useContextAwareQuestions?: boolean;
  useContextArrowsHelper?: boolean;
}

export type QuackchatSessionConfigurationResponse = QuackchatSessionConfiguration;

export type UpdateQuackchatSessionConfigurationRequest =
  Partial<QuackchatSessionConfiguration>;

export function useQuackchatSessionConfiguration(simulatorId?: string) {
  const { api } = useApi();

  const endpoint = useMemo(() => {
    return `/sessions-api/quackchat-config${
      simulatorId ? `?simulatorId=${simulatorId}` : ""
    }`;
  }, [simulatorId]);

  return useConfigManager<
    QuackchatSessionConfigurationResponse,
    UpdateQuackchatSessionConfigurationRequest
  >({
    name: simulatorId
      ? `quackchat-session-configuration-${simulatorId}`
      : "quackchat-session-configuration",
    getConfig: async () =>
      apiResolver<QuackchatSessionConfigurationResponse>(api.get(endpoint)),
    updateConfig: async (request, signal) =>
      apiResolver<QuackchatSessionConfigurationResponse>(
        api.put(
          "/sessions-api/quackchat-config",
          {
            ...request,
            ...(simulatorId ? { simulatorId } : {}),
          },
          { signal }
        )
      ),
  });
}
